"use client";

import { FEATURE_FLAGS } from ".constants/featureFlags";
import { PORTALS } from ".constants/portals";
import { Icon, cn, usePortalContext } from "@cloai/uikit";
import Image from "next/image";
import { CSSProperties, useCallback } from "react";

import { useUndressContext } from "@/providers";

import ImgSet from "./images/bdsm.webp";
import ImgPose from "./images/doggy-style.webp";
import IconKeyboard from "./images/keyboard.svg";
import ImgAnimation from "./images/lace.webp";
import ImgCostume from "./images/nude.webp";
import { START_CARD_STYLES_V2 } from "./vars";

type SettingType = "costume" | "pose";
type SettingValue = string;

export const StartV2 = () => {
  const { initialSettings, updatePhotoSetting, clickFileId, reUseFaceObj } =
    useUndressContext();
  const { openPortal } = usePortalContext();

  const handleClick = useCallback(
    (
      setting: SettingType,
      value: SettingValue,
      portal: keyof typeof PORTALS,
    ) => {
      updatePhotoSetting(clickFileId, setting, value);
      openPortal(PORTALS[portal]);
    },
    [clickFileId, openPortal, updatePhotoSetting],
  );

  const handleClickPrompt = useCallback(
    () => handleClick("costume", "prompt", "USER_FLOW_PROMPT"),
    [handleClick],
  );

  const handleClickCostume = useCallback(
    () => handleClick("pose", initialSettings.pose, "USER_FLOW_COSTUMES"),
    [handleClick, initialSettings.pose],
  );

  const handleClickPose = useCallback(
    () => handleClick("costume", "default", "USER_FLOW_POSES"),
    [handleClick],
  );

  return (
    <>
      {!reUseFaceObj && (
        <h1 className={START_CARD_STYLES_V2.title}>Choose generation mode</h1>
      )}

      <div className={START_CARD_STYLES_V2.grid}>
        {/* CLIP */}
        <div
          className={cn(
            START_CARD_STYLES_V2.card.base,
            START_CARD_STYLES_V2.card.variant.primary,
            !FEATURE_FLAGS.IS_CLIPS_ENABLED &&
              START_CARD_STYLES_V2.card.disabled,
          )}
          onClick={() => openPortal(PORTALS.USER_FLOW_CLIPS)}
        >
          <span
            className={cn(
              START_CARD_STYLES_V2.text.base,
              START_CARD_STYLES_V2.text.variant.bottom,
              START_CARD_STYLES_V2.text.variant.primary,
            )}
            data-text="Video"
          >
            Video
          </span>
          <Image
            src={ImgAnimation}
            fill
            sizes="(min-width: 768px) 50vw, 100vw"
            alt=""
            priority
            className={START_CARD_STYLES_V2.image}
          />
          <span
            className={cn(
              START_CARD_STYLES_V2.text.base,
              START_CARD_STYLES_V2.text.variant.bottom,
              START_CARD_STYLES_V2.text.variant.primary,
              START_CARD_STYLES_V2.text.variant.stroke,
            )}
            style={
              {
                WebkitTextStroke: "1px var(--color-primary)",
              } as CSSProperties
            }
          >
            Video
          </span>
          <div className={START_CARD_STYLES_V2.badge}>
            {FEATURE_FLAGS.IS_CLIPS_ENABLED ? (
              <>
                <div className="relative">
                  <Icon
                    icon="verified"
                    size={5}
                    className="absolute animate-ping opacity-20"
                  />
                  <Icon icon="verified" size={5} className="relative" />
                </div>
                Available now!
              </>
            ) : (
              "(Comming soon)"
            )}
          </div>
        </div>

        {/* COSTUME+POSE */}
        <div
          className={cn(
            START_CARD_STYLES_V2.card.variant.group,
            START_CARD_STYLES_V2.card.variant.secondary,
          )}
        >
          {/* <div
            className={START_CARD_STYLES_V2.card.base}
            onClick={handleClickCostume}
          >
            <Image
              src={ImgCostume}
              fill
              sizes="(min-width: 768px) 15vw, 33vw"
              alt=""
              priority
              className={START_CARD_STYLES_V2.image}
            />
            <div
              className={cn(
                START_CARD_STYLES_V2.text.base,
                START_CARD_STYLES_V2.text.variant.bottom,
              )}
            >
              <span>Nude</span>
            </div>
          </div> */}

          <div
            className={START_CARD_STYLES_V2.card.base}
            onClick={handleClickCostume}
          >
            <Image
              src={ImgCostume}
              fill
              sizes="(min-width: 768px) 15vw, 33vw"
              alt=""
              priority
              className={START_CARD_STYLES_V2.image}
            />
            <div
              className={cn(
                START_CARD_STYLES_V2.text.base,
                START_CARD_STYLES_V2.text.variant.bottom,
              )}
            >
              <span>Costume</span>
            </div>
          </div>

          <div
            className={START_CARD_STYLES_V2.card.base}
            onClick={handleClickPose}
          >
            <Image
              src={ImgPose}
              fill
              sizes="(min-width: 768px) 15vw, 33vw"
              alt=""
              priority
              className={START_CARD_STYLES_V2.image}
            />
            <span
              className={cn(
                START_CARD_STYLES_V2.text.base,
                START_CARD_STYLES_V2.text.variant.bottom,
              )}
            >
              Pose
            </span>
          </div>

          {/* <Icon
            icon="add"
            className="pointer-events-none absolute flex items-center justify-center text-8xl/24 font-black text-body"
          />

          <Icon
            icon="add"
            className="pointer-events-none absolute flex items-center justify-center text-7xl/18 text-card-border"
          /> */}
        </div>

        {/* PROMPT */}
        <div
          className={START_CARD_STYLES_V2.prompt}
          onClick={handleClickPrompt}
        >
          <Image
            src={IconKeyboard}
            width={150}
            height={150}
            alt="keyboard icon"
            className="absolute left-0 -rotate-12 opacity-5"
          />
          <span
            className={cn(START_CARD_STYLES_V2.text.base, "text-container-6")}
          >
            Prompt
          </span>
        </div>

        {/* COLLECTION */}
        <div
          className={cn(
            START_CARD_STYLES_V2.card.base,
            START_CARD_STYLES_V2.card.variant.regular,
          )}
          onClick={() => {
            openPortal(PORTALS.USER_FLOW_COLLECTIONS);
          }}
        >
          <span
            className={cn(
              START_CARD_STYLES_V2.text.base,
              START_CARD_STYLES_V2.text.variant.bottom,
            )}
          >
            Collection
          </span>
          <Image
            src={ImgSet}
            fill
            sizes="(min-width: 768px) 50vw, 100vw"
            alt=""
            priority
            className={START_CARD_STYLES_V2.image}
          />
          <span
            className={cn(
              START_CARD_STYLES_V2.text.base,
              START_CARD_STYLES_V2.text.variant.bottom,
              START_CARD_STYLES_V2.text.variant.stroke,
            )}
            style={
              {
                WebkitTextStroke: "1px var(--color-white)",
              } as CSSProperties
            }
          >
            Collection
          </span>
          <div className={START_CARD_STYLES_V2.badge}>
            <div className="relative">
              <Icon
                icon="cards_star"
                size={5}
                className="absolute animate-ping opacity-20"
              />
              <Icon icon="cards_star" size={5} className="relative" />
            </div>
            New staff inside
          </div>
        </div>
      </div>
    </>
  );
};
